import isNumber from 'lodash/isNumber';

export default function formatNumber(number) {
    if (!isNumber(number)) return number;
    return number.toString().replace(/(\d)(?=(\d{3})+(\.|$))/g, '$1,');
}
